import './prepacks-theme.css'
import { Outlet } from 'react-router'
import { PageContainer, StatePanel } from '@/components/common'
import { useOrganization } from '@/contexts/OrganizationContext'
import { PRODUCT_KEYS } from '@/config/studioProducts'
import { PrepackRunQueueProvider, usePrepackRunQueue } from './usePrepackRunQueue'
import { PrepackPreviewProvider } from './PrepackPreviewProvider'

function PrepacksLayoutContent() {
  const queue = usePrepackRunQueue()
  return <Outlet context={queue} />
}

function PrepacksLayout() {
  const { currentOrg, hasProductAccess } = useOrganization()

  if (!hasProductAccess(PRODUCT_KEYS.PREPACKS, 'view')) {
    return (
      <PageContainer>
        <StatePanel
          state="restricted"
          title="Prepacks is not enabled"
          description="This organization does not have access to Prepacks."
        />
      </PageContainer>
    )
  }

  const slug = currentOrg?.slug
  const canOperate = hasProductAccess(PRODUCT_KEYS.PREPACKS, 'operate')
  const canPublish = hasProductAccess(PRODUCT_KEYS.PREPACKS, 'publish')

  return (
    <div key={currentOrg?.slug} className="prepacks-workspace flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-[var(--prepacks-bg)] text-[var(--wf-color-text)]">
      <PrepackRunQueueProvider slug={slug} canOperate={canOperate} canPublish={canPublish}>
        <PrepackPreviewProvider><PrepacksLayoutContent /></PrepackPreviewProvider>
      </PrepackRunQueueProvider>
    </div>
  )
}

export default PrepacksLayout
